import { jsx as _jsx } from "react/jsx-runtime";
import { NotificationsProvider as ToolpadNotificationsProvider } from "@toolpad/core/useNotifications";
export const NotificationsProvider = ({ children, slotProps = {
    snackbar: {
        anchorOrigin: {
            horizontal: 'center',
            vertical: 'bottom'
        },
        autoHideDuration: 3000
    }
}, ...props })=>{
    return /*#__PURE__*/ _jsx(ToolpadNotificationsProvider, {
        slotProps: slotProps,
        ...props,
        children: children
    });
};
NotificationsProvider.displayName = 'NotificationsProvider';

//# sourceMappingURL=NotificationsProvider.js.map